import _ from 'lodash';

const arrayOrItemToItem = <T>(arg: T) => (Array.isArray(arg) ? arg[0] : arg);

function searchItems<T>(items: T[], term: string, properties: (keyof T | string)[]): T[] {
  return _.filter(items, (item) =>
    _.some(properties, (prop) => {
      const propParts = (prop as string).split('.');
      const value = _.get(item, propParts[0]);

      if (propParts.length > 1 && _.isArray(value)) {
        const subProp = propParts.slice(1).join('.');
        return _.some(value, (subItem) =>
          _.toString(_.get(subItem, subProp)).toLowerCase().includes(term.toLowerCase())
        );
      }

      return _.toString(value).toLowerCase().includes(term.toLowerCase());
    })
  );
}
const arrayUtil = { arrayOrItemToItem, searchItems };

export default arrayUtil;
